// composables/useMediaQuery.ts
import { ref, onMounted, onUnmounted } from "vue";

// 默认检测是否为移动端
export default function useMediaQuery(query = "(max-width: 767px)") {
	const isMatched = ref(false); // 是否匹配媒体查询
	let mediaQuery: MediaQueryList | null = null;

	// 更新匹配状态
	const updateMatch = (event: MediaQueryListEvent) => {
		isMatched.value = event.matches;
	};

	// 初始化媒体查询（仅在客户端执行）
	onMounted(() => {
		if (process.client) {
			mediaQuery = window.matchMedia(query);
			isMatched.value = mediaQuery.matches;

			// 监听媒体查询变化
			mediaQuery.addEventListener("change", updateMatch);
		}
	});

	// 组件卸载时清理监听器
	onUnmounted(() => {
		if (process.client && mediaQuery) {
			mediaQuery.removeEventListener("change", updateMatch);
		}
	});

	return { isMatched };
}
